import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MessagingService } from '../app/services/messaging.service';
import { ChartService } from '../app/services/chart.service';
import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: `<ngx-loading-bar [color]="loadingBarColor" [includeSpinner]="false"></ngx-loading-bar>
             <router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {
  message;
  loadingBarColor = getStyle('--danger');
  constructor(private router: Router, private messageService: MessagingService, private service: ChartService) { }

  // On back/forward button pressed event listener
  // To reload home page
  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    const goingTo = event.currentTarget.location.href;
    if (goingTo == 'http://localhost:4200/#/home' || goingTo =='https://smartlogger.tn/smart-control/#/home') {
      this.router.navigate(['home']).then(() => {
        window.location.reload();
      });
    }
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);

    });


    this.service.authUser().onAuthStateChanged((user) => {
      if (user != null) {
        this.service.getAllKey(user.uid).then(keyTab => {
          this.messageService.requestPermission(keyTab);
          this.messageService.receiveMessage();
          this.message = this.messageService.currentMessage;
        });
      } else {

      }
    });

  }
}
